import { toggleUrlParam } from '../utils/location';

const EnterKey = 'Enter';

document.addEventListener('turbolinks:load', () => {
  const personNameInput = document.getElementById('person-name-text-input');
  if (personNameInput) {
    personNameInput.addEventListener('keydown', (e) => {
      if (e.key === EnterKey) {
        const personName = e.target.value;
        toggleUrlParam('person_name', personName);
      }
    });
  }

  const notificationDescriptionInput = document.querySelector('[data-description-search]');
  if (notificationDescriptionInput) {
    notificationDescriptionInput.addEventListener('keydown', (e) => {
      if (e.key === EnterKey) {
        document.querySelector('#notification-search')?.click();
      }
    });
  }

  const notificationPersonInput = document.querySelector('[data-text-search]');
  if (notificationPersonInput) {
    notificationPersonInput.addEventListener('keydown', (e) => {
      if (e.key === EnterKey) {
        document.querySelector('#notification-search')?.click();
      }
    });
  }
});
